import type { PasswordFieldProps } from './password-field.interface';
import type { MouseEvent } from 'react';

import classNames from 'classnames';
import { Field } from 'formik';
import { memo, useState } from 'react';

import { MASK_TYPE } from './password-field.interface';

export const PasswordField = memo(
  ({ className, placeholder, validate, name }: PasswordFieldProps) => {
    const [mask, setMask] = useState<MASK_TYPE>(MASK_TYPE.PASSWORD);

    const toggleMask = (event: MouseEvent) => {
      event.preventDefault();
      setMask((prev) =>
        prev === MASK_TYPE.PASSWORD ? MASK_TYPE.TEXT : MASK_TYPE.PASSWORD,
      );
    };

    return (
      <div className="form__field-wrapper">
        <Field
          name={name}
          type={mask}
          component="input"
          placeholder={placeholder}
          className={classNames('form__field', className)}
          validate={validate}
        />
        <i
          className={classNames(
            'form__field_eye',
            mask === MASK_TYPE.TEXT && 'form__field_eye_active',
          )}
          onClick={toggleMask}
        />
      </div>
    );
  },
);

PasswordField.displayName = 'PasswordField';
